import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const ZTransactionHeaderUI = ({context, messageList}) =>
  <div className='txn_hdr'>
    <TabLinkUI messageList={messageList} labelKey='c_card_txns'
      active={window.location.pathname.includes('/card')}
      to={`/transactions`}
    />
    <TabLinkUI messageList={messageList} labelKey='c_bank_txns'
      active={window.location.pathname.includes('/bank')}
      to={`/txns/bank`}
    />
  </div>

export default ZTransactionHeaderUI
